import _ from 'lodash';
import ApiService from '../../../service/apiService';
import logUtils from '../../../HelperMethods/LogUtils';

const componentName = 'LogsView';

export const types = {
  LOAD_LOG_OF_A_USER: `${componentName}_LOAD_LOG_OF_A_USER`,
  LOADED_LOG_OF_A_USER_SUCCESSFULLY: `${componentName}_LOADED_LOG_OF_A_USER_SUCCESSFULLY`,
  LOADED_LOG_OF_A_USER_FAILED: `${componentName}_LOADED_LOG_OF_A_USER_FAILED`,
  CLEAR_LOGS_LIST: `${componentName}_CLEAR_LOGS_LIST`,
};

export function loadUserLogList(user, logType) {
  return async (dispatch) => {
    dispatch({ type: types.LOAD_LOG_OF_A_USER });
    try {
      const response = await ApiService.getLogsListOfAUser(user, logType);
      const success = _.get(response, 'data.rpcService.success');
      if (success) {
        let output = _.get(response, 'data.rpcService.output');
        output = JSON.parse(output);
        dispatch({ type: types.LOADED_LOG_OF_A_USER_SUCCESSFULLY, logList: output });
        return;
      }
      throw new Error(_.get(response, 'data.rpcService.message') || 'API Failed');
    } catch (error) {
      logUtils.logError(error, 'Could not fetch log list');
      dispatch({ type: types.LOADED_LOG_OF_A_USER_FAILED });
    }
  };
}

export function clearLogsList() {
  return (dispatch) => {
    dispatch({ type: types.CLEAR_LOGS_LIST });
  };
}
